export default "__VITE_PUBLIC_ASSET__2c08432f__"